<template>
  <el-dialog
    title="修改工商信息"
    :visible.sync="dialogFormEditCompanyInfo"
    @close="close"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      :rules="rules"
      label-width="100"
      ref="form"
      class="jc-form-tiny-width"
    >
      <el-form-item label="营业执照号：" prop="businessLicense">
        <el-input v-model="form.businessLicense"></el-input>
      </el-form-item>

      <el-form-item label="法定代表人：" prop="legalRepresentative">
        <el-input v-model="form.legalRepresentative"></el-input>
      </el-form-item>

      <el-form-item label="营业执照：" prop="businessLicensePic" required>
        <sk-upload
          v-model="form.businessLicensePic"
          @success="uploadSuccess"
          style="margin-top: 30px"
        ></sk-upload>

        <p slot="hint">图片尺寸建议大小：800*600px</p>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>

      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { modifySecondInfo } from '@/api/distributor-api'
import { SERVICE_PROVIDER_CREATE_RULE } from '@/views/service/rules'
export default {
  props: {
    infoData: {
      require: true,
    },
  },
  components: {},
  mixins: [],
  data() {
    return {
      dialogFormEditCompanyInfo: false,
      distributorId: this.$route.params.id,
      form: {
        businessLicense: '',
        legalRepresentative: '',
        businessLicensePic: {
          imgUrl: '',
          businessLicensePic: '',
        },
      },
      defaultForm: {},
      rules: SERVICE_PROVIDER_CREATE_RULE.call(this),
    }
  },
  watch: {
    infoData(val) {
      this.form = Object.assign({}, val)
      this.form.businessLicensePic = {
        imgUrl: this.form.businessLicensePicUri,
        businessLicensePic: this.form.businessLicensePic,
      }
      this.defaultForm = Object.assign(this.defaultForm, val)
    },
  },
  computed: {},
  mounted() {},
  created() {},
  filters: {},
  methods: {
    showDialog() {
      this.dialogFormEditCompanyInfo = true
      this.form = Object.assign({}, this.infoData)
      this.form.businessLicensePic = {
        imgUrl: this.form.businessLicensePicUri,
        businessLicensePic: this.form.businessLicensePic,
      }
      this.defaultForm = Object.assign(this.defaultForm, this.infoData)
    },
    close() {
      this.$refs.form.resetFields()
      this.dialogFormEditCompanyInfo = false
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateFirstClientInfo()
        } else {
          return false
        }
      })
    },
    uploadSuccess() {
      this.$refs['form'].validateField('businessLicensePic')
    },
    async updateFirstClientInfo() {
      let { distributorId } = this
      let { businessLicense, legalRepresentative, businessLicensePic } =
        this.form
      let submitForm = Object.assign({}, this.form)
      submitForm.distributorId = distributorId
      submitForm.businessLicensePic = businessLicensePic.businessLicensePic
      if (
        businessLicense !== this.infoData.businessLicense ||
        legalRepresentative !== this.infoData.legalRepresentative ||
        businessLicensePic.businessLicensePic !==
          this.infoData.businessLicensePic
      ) {
        await modifySecondInfo(submitForm)
        this.outMsg('success', '提交成功')
        this.close()
        this.$emit('submitSuccess')
      } else {
        this.close()
      }
    },
  },
}
</script>
